import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
    icon: ReactNode;
    iconBackgroundColor: string;
    label: ReactNode;
    value: string;
    valueColor?: string;
    loading: boolean;
};

const OverviewStat = (props: Props) => {
    const { icon, iconBackgroundColor, label, value, valueColor, loading } = props;

    return (
        <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
                sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: iconBackgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" color="text.secondary" noWrap>
                    {label}
                </Typography>
                {loading ? (
                    <Skeleton width={90} />
                ) : (
                    <Typography variant="h6" noWrap sx={{ fontWeight: 700, lineHeight: 1.3, ...(valueColor && { color: valueColor }) }}>
                        {value}
                    </Typography>
                )}
            </Box>
        </Stack>
    );
};

export default OverviewStat;
